<div class="frc-captcha" [attr.data-sitekey]="settingsService.settings.FriendlycaptchaSiteKey" data-lang="de" data-puzzle-endpoint="https://eu-api.friendlycaptcha.eu/api/v1/puzzle" #frccaptcha></div>
